import React from 'react';
import { Row, Col, Card, CardHeader, CardBody } from 'reactstrap';
import { HorizontalBar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Chart } from 'chart.js';

Chart.plugins.register(ChartDataLabels);

export function AgentHorizontalBarChart({ title, data }) {
  if (!data || !data.labels || !data.answered || !data.abandoned) return null;

  /**
   * @description: Horizontal Bar chart data
   * Data: answered and abandoned calls
   * Labels: X-axis labels
   */

  const hasManyAgents = data.labels.length > 5;

  const chartHeight = Math.max(350, data.labels.length * 60);

  const chartData = {
    labels: data.labels,
    datasets: [
      {
        label: 'Atendidas',
        data: data.answered,
        backgroundColor: '#00A07C',
        borderColor: '#00A07C',
        borderWidth: 0,
        maxBarThickness: 50,
        categoryPercentage: 0.8,
        barPercentage: 0.9,
        stack: 'Stack 0',
        datalabels: {
          color: 'white',
          font: {
            weight: 'bold',
            size: 16
          },
          align: 'center',
          offset: 10,
          formatter: (value) => (value > 0 ? value : '')
        }
      },
      {
        label: 'Abandonadas',
        data: data.abandoned,
        backgroundColor: '#d9534f',
        borderColor: '#d9534f',
        borderWidth: 0,
        maxBarThickness: 50,
        categoryPercentage: 0.8,
        barPercentage: 0.9,
        stack: 'Stack 0',
        datalabels: {
          color: 'white',
          font: {
            weight: 'bold',
            size: 16
          },
          align: 'center',
          offset: -10,
          formatter: (value) => (value > 0 ? value : '')
        }
      }
    ]
  };

  /**
   * @description: Bar chart configuration
   * Scales: X and Y axes
   * Callback: Tooltip formatting
   * Animation: Duration and easing
   * Responsive
   * Hide legend
   * Custom tooltip
   */

  const options = {
    indexAxis: 'y',
    maintainAspectRatio: false,
    responsive: true,
    animation: {
      duration: 1500,
      easing: 'easeInOutQuart'
    },
    scales: {
      x: {
        stacked: true,
        beginAtZero: true,
        ticks: {
          stepSize: 5,
          callback: (v) => v
        },
        gridLines: {
          display: false
        }
      },
      y: {
        stacked: true,
        grid: {
          display: false
        },
        ticks: {
          mirror: true,
          padding: 10,
          font: {
            size: hasManyAgents ? 10 : 12
          }
        }
      }
    },
    plugins: {
      tooltip: {
        callbacks: {
          label: (context) => {
            const value = context.parsed.x ?? context.raw;
            if (value === null || typeof value !== 'number' || isNaN(value))
              return '';
            return `${context.dataset.label}: ${value}`;
          }
        }
      },
      legend: {
        display: false
      },
      datalabels: {
        display: true
      }
    }
  };

  return (
    <Card>
      {/* Titulo Grafico de Barra */}
      <CardHeader className="title">
        <h5 className="h3 mb-0">{title}</h5>
      </CardHeader>
      <CardBody>
        <Row>
          <Col>
            {/*  Rótulo Chamadas Atendidas */}
            <div style={{ display: 'flex', gap: '20px', marginBottom: '15px' }}>
              <div
                style={{
                  backgroundColor: '#00A07C',
                  color: 'white',
                  fontWeight: '600',
                  padding: '8px 12px',
                  borderRadius: '4px'
                }}
              >
                Atendidas
              </div>
              {/*  Rótulo Chamadas Abandonadas */}
              <div
                style={{
                  backgroundColor: '#d9534f',
                  color: 'white',
                  fontWeight: '600',
                  padding: '8px 12px',
                  borderRadius: '4px'
                }}
              >
                Abandonadas
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            {/* Grafico de Barra */}
            <div
              style={{
                height: '350px',
                overflowY: hasManyAgents ? 'auto' : 'hidden'
              }}
            >
              <div style={{ height: `${chartHeight}px` }}>
                <HorizontalBar data={chartData} options={options} />
              </div>
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
}
